import Axios from 'axios';
import Select from '../../core/select/select';
import animationHeight from '../../core/animation/height/animation-height';
import animationFade from '../../core/animation/fade/animation-fade';
import FilterTemplate from './filter.pug';
import filterPopup from './popup/filter-popup';

require('custom-event-polyfill');

/* eslint-disable */
function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export default {
  props: {
    catalog: String, 
    filterButton: {
      type: String,
      default: 'Фильтр',
    }, 
    applyButton: {
      type: String,
      default: 'Применить',
    }, 
    cancelButton: {
      type: String,
      default: 'Сбросить',
    },
    currencies: {
      type: Array,
      default: () => [
        {value: 'rub', caption: 'руб.'},
        {value: 'dollar', caption: '$'},
        {value: 'euro', caption: '€'},
        {value: 'frank', caption: '₣'},
        {value: 'pound', caption: '£'},
      ]
    }
  },
  template: FilterTemplate(),
  components: {
    animationHeight,
    animationFade,
    filterPopup
  },
  data(vm) {
    return {
      isOpen: false,
      action: vm.$props.catalog,
      filters: window.filters,
      filterData: clone(window.defaultValues),
      windowWidth: window.innerWidth,
      defaultValues: window.defaultValues,
      popupOpened: false,
      popupData: null,
      count: 0,
      dataNames: {},
      currency: 'rub',
    };
  },
  watch: {
    windowWidth: {
      handler() {
        this.isOpen = this.windowWidth >= 768;
        if (this.isOpen) {
          this.initSelects();
        }
      }
    },
    visibleFields() {
      this.visibleFields.forEach((field) => {
        if (field.condition && field.type === 'select') {
          this.filterData[field.name] = field.values.find(el => el.selected).value;
        }
      });

      if (this.isOpen) {
        this.initSelects();
      }
    }
  },
  computed: {
    visibleFields() {
      return this.showFields(this.filters);
    }
  },
  methods: {
    inputPrice(event) {
      this.filterData[event.target.name] = event.target.value.replace(/[^\d]/g, '').replace(/(\w)(?=(\w{3})+(?!\w))/g, '$1 ');
    },
    changePrice(event) {
      this.arrInput = this.$refs.priceInput
      this.indexInput = this.arrInput.indexOf(event.target);

      if (this.indexInput > -1 && this.arrInput[1].value !== '') {
        this.min = Number(this.arrInput[0].value.toString().replace(/\s/g, ''));
        this.max = Number(this.arrInput[1].value.toString().replace(/\s/g, ''));

        if (this.min > this.max ) {
          this.filterData[this.arrInput[0].name] = this.arrInput[1].value;
        }
      }
    },
    setCount(e) {
      if ((e.target.dataset && e.target.dataset.name && !this.dataNames[e.target.dataset.name]) || e.target.name && !this.dataNames[e.target.name]) {
        this.dataNames[e.target.dataset.name] = true;
        this.count += 1;
      }

      const sell = e.target.value === '1';
      const rent = e.target.value === '2';
      if (rent || sell ) {
        if (rent) {
          this.filterData.amount = window.defaultValues.amount_for_rent;
        } if (sell && this.currency === 'rub') {
          this.filterData.amount = window.defaultValues.amount_for_sale;
        } else {
          this.filterData.amount = window.defaultValues.amount_for_rent;
        }
      }
    },
    showFields(fields) {
      const visibleFields = [];
      if (fields && fields.length !== 0) {
        fields.forEach((el) => {
          if (el.condition) {
            const conditions = el.condition;
            const allMatched = Object.keys(conditions).every(key => {
              const isFalse = key[0] !== '!' ? key : false;
              return this.filterData.hasOwnProperty(`${isFalse}`) && this.filterData[`${isFalse}`] == conditions[`${key}`]
            });
            const notMatched = Object.keys(conditions).every(key => {
              const isFalse = key[0] === '!' ? key.slice(1) : false;
              if (!isFalse) {
                return this.filterData.hasOwnProperty(`${key}`) && this.filterData[`${key}`] == conditions[`${key}`]
              }
              return this.filterData.hasOwnProperty(`${isFalse}`) && this.filterData[`${isFalse}`] != conditions[`${key}`]
            });
            let isNot = false;
            Object.keys(conditions).forEach((key) => {
              const isFalse = key[0] === '!' ? key.slice(1) : false;
              if (isFalse && notMatched) {
                visibleFields.push(el);
                isNot = true;
                this.updateMinMax(el);
              }
            });
            if (!isNot && allMatched) {
              visibleFields.push(el);
              this.updateMinMax(el);
            }
          } else visibleFields.push(el);
        });
      }
      return visibleFields;
    },
    updateMinMax(el) {
      if (el.hasOwnProperty('inputMin') && this.filterData[el.name]) {
        this.filterData[el.name].min = el.inputMin;
      }
      if (el.hasOwnProperty('inputMax') && this.filterData[el.name]) {
        this.filterData[el.name].max = el.inputMax;
      }
    },
    toggleFilter() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.initSelects();
      }
    },
    updateInput(evt, model, type) {
      this.setCount(evt);
      model[type] = parseFloat(evt.target.value);
    },
    initSelects(clear = false) {
      this.$nextTick(() => {
        const selects = [].slice.call(this.$el.querySelectorAll('.select'));
        if (selects.length !== 0) {
          selects.forEach((el) => {
            if (clear) {
              const selects = [].slice.call(el.querySelectorAll('select'));
              selects.forEach((select, index) => {
                if (!select.multiple) {
                  const options = [].slice.call(select.options);
                  if (index > 0) {
                    select.value = options[options.length - 1].value;
                  } else {
                    select.value = options[0].value;
                  }
                }
              });
            }
            if (!el.classList.contains('cselect--inited')) {
              el.select = new Select(el);
            } else {
              const cselect = el.querySelector('.cselect');
              if (cselect) {
                el.select = el.removeChild(cselect);
                el.select = null;
              }
              el.select = new Select(el);
            }
          });
        }
      });
    },
    filterSubmit() {
      this.submitFunc();
    },
    clear() {
      this.filterData = clone(window.defaultValues);
      this.count = 0;
      if (this.isOpen) {
        this.initSelects(true);
      }
    },
    togglePopup(popup, dataUrl) {
      if (!this.popupData) {
        Axios.get(dataUrl).then((resp) => {
          this.popupData = resp.data;
          this.$nextTick(() => {
            this.popupOpened = !!popup;
          });
        });
      } else {
        this.popupOpened = !!popup;
      }
    },
    savePopup(data) {
      Object.assign(this.filterData, data);
    },
    changeSelect(event) {
      this.currency = event.target.value;
      if (this.filterData.dealType === '1') {
        this.filterData.amount = window.defaultValues.amount_for_sale;
      }
      // if (this.filterData.dealType === '1') {
      //   this.filterData.amount = this.currency === 'rub' ? 'млн': 'тыс';
      // } else {
      //   this.filterData.amount = 'тыс';
      // }
    }
  },
  mounted() {
    if (this.filterData.dealType === '2') {
      this.filterData.amount = window.defaultValues.amount_for_rent;
    };
    this.$parent.action = this.action;
    this.submitFunc = window.debounce(() => {
      this.filterDataCopy = Object.assign({}, this.filterData);
      this.priceFrom = this.filterDataCopy.price_from ? this.filterDataCopy.price_from.replace(/\s/g, '') : '';
      this.priceTo = this.filterDataCopy.price_to ? this.filterDataCopy.price_to.replace(/\s/g, '') : '';
      this.filterDataCopy.amount === 'млн' ? this.priceFrom *= 1000000 : this.priceFrom *= 1000;
      this.filterDataCopy.amount === 'млн' ? this.priceTo *= 1000000 : this.priceTo *= 1000;
      this.filterDataCopy.price_from = this.priceFrom;
      this.filterDataCopy.price_to = this.priceTo;
      this.$emit('filter-submit', this.filterDataCopy);
    }, 300);
    this.isOpen = this.windowWidth >= 767;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
    if (this.isOpen) {
      this.initSelects();
    }
  },
  updated() {
    if (this.$el.classList.contains('filter--new')) {
      if (this.$refs.filterSubmit) {
        this.$refs.filterSubmit.classList.add('btn--wine');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./blocks/filter/filter.js